import {USER_DATASHAPE} from "./user-datashape";
export const USER_TOKEN_DATASHAPE = `
    token
    user {
        ${USER_DATASHAPE}
    }
`;